import { Component, OnInit, OnDestroy } from "@angular/core"
import { BrowsingService } from "../../services/browsing.service"
import { CHNode } from "../../models/node.model"
import { Subscription } from "rxjs"

@Component({
    selector: "app-subjects",
    templateUrl: "./subjects.component.html",
    styleUrls: ["./subjects.component.scss"],
})
export class SubjectsComponent implements OnInit, OnDestroy {
    subjects: CHNode[]
    subscriptions: Subscription[] = []
    public gtmPrefix: string = "gtm-browse-by-subject-"

    constructor(private browsingService: BrowsingService) {}

    ngOnInit() {
        this.subscriptions.push(
            this.browsingService.activeNodeChanged.subscribe(
                (node) => (this.subjects = node.children)
            )
        )
    }

    ngOnDestroy() {
        this.subscriptions.map((subscription) => subscription.unsubscribe())
    }
}
